export default __webpack_public_path__ + "static/media/panelData5.881b4d10.png";